import { GetHouseNextValidPeriodRepository } from "./interfaces/GetHouseNextValidPeriodRepository";
import { GetHouseNextValidPeriodPresentation } from "./interfaces/GetHouseNextValidPeriodPresentation";

export default class GetHouseNextValidPeriodUseCase {
  constructor(private repository: GetHouseNextValidPeriodRepository) {}

  async execute(
    presenter: GetHouseNextValidPeriodPresentation,
    houseId: string
  ) {
    const response = await this.repository.getHouseNextValidPeriod({
      houseId,
    });

    if (response.data) {
      presenter.displayHouseNextValidPeriod(response?.data);
    } else {
      presenter.displayHouseNextValidPeriod(null);
    }
  }
}
